import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://eumonitoro.com.br:5001/api';
export const API_ORIGIN = API_URL.replace(/\/api\/?$/, "");
let redirectingToLogin = false;

const safeParseUser = () => {
    try {
        return JSON.parse(localStorage.getItem("user") || "{}");
    } catch (error) {
        return {};
    }
};


export const api = axios.create({
    baseURL: API_URL,
});

export const resolveAssetUrl = (value) => {
    if (!value) return "";
    if (/^https?:\/\//i.test(value) || value.startsWith("data:")) {
        return value;
    }
    return `${API_ORIGIN}${value.startsWith("/") ? value : `/${value}`}`;
};

export const buildApiUrl = (path) => `${API_URL}${path.startsWith("/") ? path : `/${path}`}`;

const clearSessionAndRedirect = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("empresa_scope");
    localStorage.removeItem("active_empresa_id");
    localStorage.removeItem("branding_city");

    if (redirectingToLogin) return;
    redirectingToLogin = true;

    const loginPath = "/sistema";
    if (typeof window !== "undefined" && window.location.pathname !== loginPath) {
        window.location.replace(loginPath);
    }
};

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    const user = safeParseUser();
    const userRole = String(user?.role || "").toLowerCase();
    const activeEmpresaId = Number(localStorage.getItem("active_empresa_id"));
    const canOverrideEmpresa = ["superadmin", "owner", "admin"].includes(userRole);

    if (canOverrideEmpresa && Number.isInteger(activeEmpresaId) && activeEmpresaId > 0) {
        config.headers["x-empresa-id"] = activeEmpresaId;
    } else if (user?.empresa_id) {
        config.headers["x-empresa-id"] = user.empresa_id;
    }
    const scope = localStorage.getItem("empresa_scope");
    if (scope) {
        config.headers["x-empresa-scope"] = scope;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const url = String(error?.config?.url || "");
        const isLoginRequest = url.includes("/usuarios/login");

        if (status === 401 && !isLoginRequest) {
            clearSessionAndRedirect();
        }

        return Promise.reject(error);
    }
);
